var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTemperature(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 9.87C13.1756 9.58992 13.4108 9.35198 13.6889 9.17311C13.9669 8.99425 14.2809 8.87885 14.6086 8.83513C14.9363 8.79141 15.2696 8.82044 15.5848 8.92015C15.9 9.01987 16.1894 9.18782 16.4323 9.41206C16.6753 9.6363 16.8658 9.91132 16.9904 10.2175C17.1149 10.5238 17.1705 10.8537 17.1531 11.1838C17.1357 11.514 17.0457 11.8362 16.8896 12.1277C16.7336 12.4191 16.5152 12.6726 16.25 12.87",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 6.87L13.36 5.6",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.81 13.02L19.98 13.65",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.13 9.74L20.4 9.35",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.03 7.19L17.66 6.02",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 17.53C15.5664 17.395 16.074 17.0806 16.4471 16.6336C16.8202 16.1866 17.0388 15.6309 17.0702 15.0495C17.1017 14.4681 16.9444 13.8921 16.6218 13.4074C16.2992 12.9228 15.8285 12.5553 15.28 12.36C14.7962 12.2089 14.2819 12.1828 13.7853 12.2842C13.2887 12.3857 12.8258 12.6113 12.44 12.94C11.745 13.6049 11.1579 14.3742 10.7 15.22C9.53 16.96 7.23 18.22 5.19 17.15C4.70202 16.8979 4.29443 16.5142 4.0134 16.0422C3.73238 15.5703 3.58917 15.0291 3.6 14.48C3.6 13.6525 3.92871 12.8589 4.51383 12.2738C5.09894 11.6887 5.89252 11.36 6.72 11.36H7.16C7.34029 10.7902 7.66386 10.2763 8.09971 9.86749C8.53557 9.45864 9.0691 9.16856 9.64921 9.02504C10.2293 8.88152 10.8366 8.88936 11.4128 9.04782C11.989 9.20628 12.5148 9.51003 12.94 9.93C13.1379 10.1295 13.3124 10.3509 13.46 10.59",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperature);
export default __webpack_public_path__ + "static/media/temperature.e4d33b06496913b582961f8124a902d5.svg";
export { ForwardRef as ReactComponent };